module.exports = __webpack_public_path__ + "img/as.70ce43c7.svg";